/**
 * Service to manage URL redirections using sessionStorage
 */
class RedirectService {
    private key = 'redirect'

    /**
     * Stores a URL to redirect to in sessionStorage
     * @param to The URL to redirect to
     */
    public redirectTo(to: string) {
        sessionStorage.setItem(this.key, to)
    }

    /**
     * Gets the stored redirect URL from sessionStorage
     * @param clear Whether to clear the stored URL after retrieving it
     * @returns The stored redirect URL or null if not found
     */
    public getRedirectUrl(clear = false) {
        const url = sessionStorage.getItem(this.key)
        if (clear) sessionStorage.removeItem(this.key)

        return url ?? '/'
    }

    /**
     * Clears the stored redirect URL from sessionStorage, useful for unmount/cleanup situations
     */
    public clearRedirectUrl() {
        sessionStorage.removeItem(this.key)
    }

    /**
     * Checks if there is a redirect URL stored
     * @returns True if a redirect URL exists, false otherwise
     */
    public get hasRedirectUrl() {
        return !!this.getRedirectUrl()
    }
}

export const redirectService = new RedirectService()
